import { SVGFC } from '@repo/toolkit/types'

const ArrowRightOneIcon: SVGFC = ({ color = 'white', ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.7722 18.1798L18.1911 12.7676C18.2898 12.6647 18.3671 12.5433 18.4187 12.4104C18.5271 12.1469 18.5271 11.8513 18.4187 11.5877C18.3671 11.4549 18.2898 11.3335 18.1911 11.2305L12.7722 5.81834C12.6711 5.71741 12.5512 5.63735 12.4191 5.58273C12.2871 5.52811 12.1456 5.5 12.0027 5.5C11.7141 5.5 11.4373 5.61451 11.2332 5.81834C11.0291 6.02217 10.9145 6.29861 10.9145 6.58687C10.9145 6.87513 11.0291 7.15158 11.2332 7.3554L14.8097 10.9166L6.58378 10.9166C6.29635 10.9166 6.02068 11.0307 5.81743 11.2337C5.61418 11.4367 5.5 11.712 5.5 11.9991C5.5 12.2862 5.61418 12.5615 5.81743 12.7645C6.02068 12.9675 6.29635 13.0815 6.58378 13.0815L14.8097 13.0815L11.2332 16.6428C11.1316 16.7434 11.051 16.8631 10.996 16.995C10.941 17.1269 10.9126 17.2684 10.9126 17.4113C10.9126 17.5542 10.941 17.6957 10.996 17.8276C11.051 17.9595 11.1316 18.0792 11.2332 18.1798C11.334 18.2813 11.4538 18.3618 11.5859 18.4168C11.718 18.4717 11.8596 18.5 12.0027 18.5C12.1458 18.5 12.2874 18.4717 12.4195 18.4168C12.5516 18.3618 12.6714 18.2813 12.7722 18.1798Z"
        fill={color}
      />
    </svg>
  )
}

export default ArrowRightOneIcon
